/**
 * "Complete the look" upsell interactions for the cart drawer.
 *
 * Two buttons come out of cart-complete-the-look.liquid:
 *   [data-ctl-add="<variantId>"]  single-variant product, add straight to the cart
 *   [data-ctl-open]               multi-variant product, open the variant panel first
 *
 * Events are delegated from the drawer rather than bound to the buttons, because the
 * upsell row lives inside [data-minimog-cart-items] and is replaced wholesale on every
 * cart update. The panel itself is rendered OUTSIDE that container so it survives a
 * refresh while it is open.
 *
 * Add + refresh mirrors cart-free-gift.js so all cart mutations behave the same way.
 */
(function () {
  const rootUrl = (window.MinimogSettings && window.MinimogSettings.routes.root) || '/';
  let busy = false;

  const drawer = () => document.querySelector('#MinimogCartDrawer');
  const panel = () => document.querySelector('[data-ctl-panel]');

  function refreshCart() {
    return fetch(`${rootUrl}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const d = drawer();
        if (d) {
          if (typeof d.onCartDrawerUpdate === 'function') d.onCartDrawerUpdate();
          d.classList.toggle('m-cart--empty', cart.item_count === 0);
        }
        if (window.MinimogEvents && window.MinimogTheme) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, cart);
        }
      });
  }

  function addVariant(id, button) {
    if (busy || !id) return;
    busy = true;
    if (button) button.classList.add('is-loading');

    fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then((r) => r.json())
      .then(() => refreshCart())
      .catch(() => {})
      .finally(() => {
        busy = false;
        if (button) button.classList.remove('is-loading');
        closePanel();
      });
  }

  function openPanel(button) {
    const el = panel();
    if (!el) return;

    let variants = [];
    try {
      variants = JSON.parse(button.getAttribute('data-ctl-variants') || '[]');
    } catch (e) {
      variants = [];
    }
    if (!variants.length) return;

    const optionName = button.getAttribute('data-ctl-option') || 'option';
    el.querySelector('[data-ctl-panel-title]').textContent = `Select a ${optionName}`.toUpperCase();

    const list = el.querySelector('[data-ctl-panel-list]');
    list.innerHTML = '';
    variants.forEach((v) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'm-ctl-panel__row';
      row.setAttribute('data-ctl-choose', v.id);
      row.innerHTML =
        `<span class="m-ctl-panel__swatch" style="background:${v.swatch}"></span>` +
        `<span class="m-ctl-panel__text">` +
        `<span class="m-ctl-panel__name"></span>` +
        `<span class="m-ctl-panel__note"></span>` +
        `</span>` +
        `<span class="m-ctl-panel__price"></span>`;
      // textContent rather than interpolation so merchant-authored notes can never
      // inject markup into the drawer.
      row.querySelector('.m-ctl-panel__name').textContent = v.title;
      row.querySelector('.m-ctl-panel__note').textContent = v.note || '';
      row.querySelector('.m-ctl-panel__price').textContent = v.price || '';
      list.appendChild(row);
    });

    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
  }

  function closePanel() {
    const el = panel();
    if (!el) return;
    el.classList.remove('is-open');
    setTimeout(() => {
      if (!el.classList.contains('is-open')) el.hidden = true;
    }, 220);
  }

  document.addEventListener('click', (event) => {
    const addBtn = event.target.closest('[data-ctl-add]');
    if (addBtn) {
      event.preventDefault();
      addVariant(addBtn.getAttribute('data-ctl-add'), addBtn);
      return;
    }

    const openBtn = event.target.closest('[data-ctl-open]');
    if (openBtn) {
      event.preventDefault();
      openPanel(openBtn);
      return;
    }

    const choose = event.target.closest('[data-ctl-choose]');
    if (choose) {
      event.preventDefault();
      addVariant(choose.getAttribute('data-ctl-choose'), choose);
      return;
    }

    if (event.target.closest('[data-ctl-panel-close]') || event.target.matches('[data-ctl-panel-backdrop]')) {
      event.preventDefault();
      closePanel();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanel();
  });

  /**
   * Keep the item count in the drawer title honest.
   *
   * The count is rendered in .m-cart-drawer__header, which is NOT one of the four
   * selectors the drawer re-renders on a cart update - so without this it keeps
   * showing whatever the count was when the page loaded. Applies to every cart
   * mutation (quantity, remove, upsell add), not just this module's.
   */
  function syncCount(cart) {
    const title = document.querySelector('.m-cart-drawer__title');
    if (!title || !cart) return;

    let el = title.querySelector('.m-cart-drawer__count');
    if (!cart.item_count) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('span');
      el.className = 'm-cart-drawer__count';
      title.appendChild(el);
    }
    el.textContent = `: ${cart.item_count}`;
  }

  (function subscribe(attempts) {
    if (window.MinimogEvents && window.MinimogTheme) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, syncCount);
      return;
    }
    // The pub/sub bus is set up by the theme bundle, which may land after this file.
    if (attempts > 0) setTimeout(() => subscribe(attempts - 1), 150);
  })(20);
})();
